module.exports = __webpack_public_path__ + "img/skv_logo.56884eba.png";